import {Box} from '@mantine/core'
import {type ChangeEventHandler, type FocusEventHandler, useState} from 'react'

const titleSizerStyle = {
    visibility: 'hidden' as const,
    whiteSpace: 'pre' as const,
    fontSize: 'var(--mantine-h1-font-size)',
    fontWeight: 'var(--mantine-h1-font-weight)',
    lineHeight: 'var(--mantine-h1-line-height)',
    fontFamily: 'var(--mantine-font-family-headings)',
    padding: 0,
    border: 'none',
    gridArea: '1 / 1',
}

const titleInputStyle = {
    width: '100%',
    minWidth: 0,
    border: 'none',
    outline: 'none',
    background: 'transparent',
    padding: 0,
    margin: 0,
    fontSize: 'var(--mantine-h1-font-size)',
    fontWeight: 'var(--mantine-h1-font-weight)',
    lineHeight: 'var(--mantine-h1-line-height)',
    fontFamily: 'var(--mantine-font-family-headings)',
    color: 'var(--mantine-color-text)',
}

type AutoWidthTitleInputProps = {
    value: string
    onChange: ChangeEventHandler<HTMLInputElement>
    ariaLabel: string
}

/** Inline h1-sized input that grows with its content. */
export function AutoWidthTitleInput({value, onChange, ariaLabel}: AutoWidthTitleInputProps) {
    const [isFocused, setIsFocused] = useState(false)

    const handleFocus: FocusEventHandler<HTMLInputElement> = () => {
        setIsFocused(true)
    }

    const handleBlur: FocusEventHandler<HTMLInputElement> = () => {
        setIsFocused(false)
    }

    return (
        <Box
            style={{
                display: 'inline-grid',
                alignItems: 'center',
                maxWidth: '100%',
                minWidth: 0,
                borderBottom: `2px solid ${
                    isFocused ? 'var(--mt-brand-accent)' : 'var(--mantine-color-gray-4)'
                }`,
                paddingBottom: 4,
            }}
        >
            <Box component="span" aria-hidden style={titleSizerStyle}>
                {value || '\u00a0'}
            </Box>
            <Box
                component="input"
                type="text"
                aria-label={ariaLabel}
                value={value}
                onChange={onChange}
                onFocus={handleFocus}
                onBlur={handleBlur}
                style={{...titleInputStyle, gridArea: '1 / 1'}}
            />
        </Box>
    )
}
